import React from 'react';
import Helmet from 'react-helmet';
import * as _ from 'lodash';
import moment from 'moment';
import ClipLoader from 'react-spinners/ClipLoader';
import { isTargetRoleId } from '../utilities/roleUtility';
import {
  APPROVAL_STATUS,
  USER_ROLES,
  LIST_LIMIT,
  EXTERNAL_SYSTEM_TYPE,
} from '../utilities/constants';
import _slideLoader from '../utilities/slideLoader';
import dialogLoader from '../utilities/dialogLoader';
import { ErrorDialog } from '../components/dialogs/ErrorDialog';
import { SchaduleBar } from '../components/gagebar/bar';
import InfinityScrollLoad from '../components/InfinityScrollLoad';
import { Modal } from '../components/Modal';
import PrimeContractorToggle from '../components/toggle/PrimeContractorToggle';
import { TimeBarHeader } from '../components/gagebar/bar';
import Confirmation from '../components/modals/common/Confirmation';
import CopyPlan from '../components/modals/common/CopyPlan';
import DisableTime from '../components/modals/common/DisableTime';
import Information from '../components/modals/common/Information';
import { MachineryUsesSearchForm } from '../components/searchmenus/MachineryUses';
import { MachineryUsesContents } from '../components/tables/MachineryUses';
import { MachineryUseDocuments } from './modals/Commons';
import { CopyMachineryUsesIchiPlusWarning } from '../components/modals/MachineryUsesDialog';

import { FieldService } from '../services/Fields'; // 現場マスタAPI
import { MachineryService } from '../services/Machineries';
import { MachineryUseService } from '../services/MachineryUses';
import { PrintService } from '../services/Prints'; // 帳票API
import { ScheduleLimitTimeService } from '../services/ScheduleLimitTimes';
import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';
import {
  WORK_HOUR_ZONES, // 作業時間帯
  SCHEDULE_TYPES, // 予定種別
  HEADER_CONSTANTS, // ヘッダータイトル
  FILE_CODE,
  CONFERENCE_MODE, //会議モード
  STATUS_CODE,
  USER_ROLES_IDS,
} from '../utilities/constants';
import EventMg from '../utilities/EventManager';
import { messageUtility } from '../utilities/messageUtility';
import PrintUtility from '../utilities/printUtility';
import ReportNames from '../utilities/reportNames';
import {
  isPrimaryCompanyRoleId,
  isPartnerCompanyRoleId,
} from '../utilities/roleUtility';
import ReloadHelper from '../services/utilities/ReloadHelper';
import urlParamManager from '../utilities/urlParamManager';
import { onceAsyncRequest } from '../utilities/commonUtil';
import { ConferencePageHeader } from '../components/PageHeader';

const MY_EVENT = {
  LOAD_MACHINERY_USES_DATA: 'load_machinery_uses_data', // 一覧取得
};

// 絞り込みキー
const paramsDefault = {
  approval_flag: null,
  spot_flag: null,
  machinery_id: [],
  field_tree_id: [],
  manager_user_id: [],
  field_group_id: [],
};

/**
 * @description 機材予定一覧画面
 */
export class MachineryUses extends React.Component {
  constructor(props) {
    super(props);

    this._scroller = React.createRef();
    this._rightTable = React.createRef();
    this.innerWindow = React.createRef();

    // カレンダー指定時間をStateに反映する
    const fromDate = SessionStorageService.getItem('date_from');
    const toDate = SessionStorageService.getItem('date_to');
    const workHourZone = SessionStorageService.getItem('work_hour_zone');

    const roleId = LocalStorageService.getRoleId();
    const currentStartDate = SessionStorageService.getFromDate();
    let viewOnlyFlag = false;
    if (
      isPartnerCompanyRoleId(roleId) &&
      moment(currentStartDate).isBefore(moment().format('YYYY/MM/DD'))
    ) {
      viewOnlyFlag = true;
    }

    this.state = {
      total: 0,
      machinerySortedIds: [],
      machineries: {}, // 機材マスタ一覧
      machineryLoaded: false, // 機材マスタロード完了フラグ
      fieldId: SessionStorageService.getFieldId(),
      roleId,
      fromDate,
      toDate,
      workHourZone,
      viewOnlyFlag, // 閲覧制限フラグ

      selectedList: {}, // 選択した機材予定のIDを管理
      // { groupId1: [itemId1, itemId2, ... ], groupId2: ... }
      // という形式で値が入っている

      selectedGroup: {}, // グループ単位で選択した機材マスタを管理
      // { groupId1: true, groupId2: true }
      // という形式で値が入っている

      isOpened: false, // 検索フォーム開閉フラグ
      refresh: false, // 検索条件クリアフラグ
      use_date: moment().format('YYYY/MM/DD'), // コピーする日付
      workTime: {}, // 現場に設定されている作業時間を格納
      calling: false, // 帳票通信中フラグ
      modalVisible: {
        // ダイアログ表示・非表示フラグ
        approval: false, // 承認
        disapproval: false, // 承認解除
        approvalSingle: false, // 行単位の承認
        disapprovalSingle: false, // 行単位の承認解除
        disableTime: false, // 禁止時間帯
        documents: false, // 帳票
        documentsError: false, // 帳票出力エラー
        confirmation: false, // 禁止時間帯削除確認
        approvalStatus: false, // 承認状態
        approvalTitle: '', // 承認/承認解除結果ダイヤログのタイトル
        approvalMessage: '', // 承認、未承認時のメッセージ
        failure: false, //禁止時間帯削除失敗
        success: false, //禁止時間帯削除成功
        timeForbiddenError: false, // 時間更新権限エラー
        copyForbiddenError: false, // コピー権限エラー
        copyNotComplete: false, // 不完全コピー：作業終了の元請担当者はクリアしてコピー
      },
      apiMessage: null, // APIレスポンスメッセージ(帳票出力エラー用)
      searchConditions: _.cloneDeep(paramsDefault), // 検索条件
      tempSearchConditions: _.cloneDeep(paramsDefault), // 検索条件(保存用)
      scheduleLimitTimes: [
        {
          schedule_type: SCHEDULE_TYPES.machinery.id,
          target_id: '',
          limit_start_date: fromDate,
          limit_start_time: '',
          limit_end_time: '',
        },
      ],
      disabledTimes: [],
      loadingDisabledTimes: false, // 禁止時間帯取得中フラグ
      deleteScheduleLimitTimeIds: [], // 削除禁止時間帯設定ID
      one_machinery_id: [],
      one_machinery_flag: false,
      isLoading: true, // ロード中フラグ
      isTimeBarReset: false, // 時間バーリセットフラグ
      clientX: 0,
      scrollLeft: 0,
      isScrolling: false,
      ref: this._scroller,
      isConferenceMode: false,
      innerWidth: window.innerWidth,
    };

    //新規フォーム用のコールバックと値
    this.FormNew = {
      callback: {
        submit: () => {
          console.log('Submit');
        },
      },
      state: { currentDate: this.state.fromDate },
      // MachineryUseRegister.jsx に
      // this.props.view.state.currentDate
      // として値が伝達される
    };

    this.events = {
      modal: {
        handleVisible: this.handleVisible.bind(this), // ダイアログ表示・非表示イベント
        approval: this.approvalMachineryUses.bind(this), // 承認
        disapproval: this.disapprovalMachineryUses.bind(this), // 否認
        calender: this.setDate.bind(this), // 日付セット
        copy: this.copyMachineryUses.bind(this), // コピー
        dropdown: this.setDisableMachineries.bind(this), // ドロップダウンで選択した値をセット
        destroy: this.destroyScheduleLimitTimes.bind(this), // 禁止時間帯クリア
        add: this.addLimitTime.bind(this), // 禁止時間帯追加
        set: this.setLimitTime.bind(this), // 禁止時間帯設定
        remove: this.removeLimitTime.bind(this), // 禁止時間帯追加項目削除
        submit: this.updateDisabledTimes.bind(this), // 禁止時間帯設定API
        print: this.callDocurain.bind(this), // 帳票
      },
      search: {
        handleFormOpen: this.handleFormOpen.bind(this), // 検索フォーム開閉イベント
        clearConditions: this.clearConditions.bind(this), // 検索条件クリア
        setSingleCondition: this.setSingleCondition.bind(this), // 承認・スポットフラグを検索条件にセット
        dropdown: this.setMultiCondition.bind(this), // ドロップダウンで選択した値をセット
        setSearchCondition: this.setSearchCondition, // 検索条件にセット
      },
      table: {
        handleSelectedRow: this.handleSelectedRow.bind(this), // 機材予定を単一選択
        handleSelectedAll: this.handleSelectedAll.bind(this), // 取得した機材予定を全選択
        handleSelectedGroup: this.handleSelectedGroup.bind(this), // 機材予定をグループ単位で選択
        handleSeeMore: this.fetchMachineryUses.bind(this), // 機材予定を10件ごとに取得
        handleGageUpdate: this.handleGageUpdate.bind(this), //ゲージの時間更新
        edit: this.editRow.bind(this), // 編集画面へ遷移
      },
    };

    this.checkShadow = this.checkShadow.bind(this);
    this.getTotal = this.getTotal.bind(this); // 総数取得
    this.isSelected = this.isSelected.bind(this); // 単一選択判定
    this.createParams = this.createParams.bind(this); // 承認・否認する際のparam生成
    this.getMachineries = this.getMachineries.bind(this); // 機材マスタ取得
    this.isSelectedGroup = this.isSelectedGroup.bind(this); // グループ選択判定
    this.getMachineryUses = this.getMachineryUses.bind(this); // 機材予定取得
    this.isShowRegisterButton = this.isShowRegisterButton.bind(this);
    this.someSelectedList = this.someSelectedList.bind(this); // 選択したデータがあるか判定
    this.updatedMachineryUses = this.updatedMachineryUses.bind(this); // stateに保持している機材予定と、更新した機材予定を書き換える
    this.getDisabledTimes = this.getDisabledTimes.bind(this); // 予定禁止時間取得

    // 一覧取得イベント登録
    EventMg.registerEvent(MY_EVENT.LOAD_MACHINERY_USES_DATA);
    EventMg.addEventListener(MY_EVENT.LOAD_MACHINERY_USES_DATA, isNotUpdate => {
      if (!isNotUpdate) {
        this.reLoad();
        this.getTotal();
      }
    });

    this.clearFlag = false;
    this.isRequestingFlag = false;
  }

  componentDidMount() {
    FieldService.info(this.state.fieldId).then(response => {
      if (response.result) {
        const field = response.data.entities.field;
        let workTime = this.state.workTime;
        workTime[WORK_HOUR_ZONES.day.id] = _.assign(
          workTime[WORK_HOUR_ZONES.day.id],
          { start: field.work_start_time }
        ); // 労働開始時刻（昼）
        workTime[WORK_HOUR_ZONES.day.id] = _.assign(
          workTime[WORK_HOUR_ZONES.day.id],
          { end: field.work_end_time }
        ); // 労働終了時刻（昼）
        workTime[WORK_HOUR_ZONES.night.id] = _.assign(
          workTime[WORK_HOUR_ZONES.night.id],
          { start: field.work_start_time_night }
        ); // 労働開始時刻（夜）
        workTime[WORK_HOUR_ZONES.night.id] = _.assign(
          workTime[WORK_HOUR_ZONES.night.id],
          { end: field.work_end_time_night }
        ); // 労働終了時刻（夜）
        workTime[WORK_HOUR_ZONES.midnight.id] = _.assign(
          workTime[WORK_HOUR_ZONES.midnight.id],
          { start: field.work_start_time_midnight }
        ); // 労働開始時刻（深夜）
        workTime[WORK_HOUR_ZONES.midnight.id] = _.assign(
          workTime[WORK_HOUR_ZONES.midnight.id],
          { end: field.work_end_time_midnight }
        ); // 労働終了時刻（深夜）

        // 作業時間帯
        let scheduleLimitTimes = this.state.scheduleLimitTimes;
        scheduleLimitTimes[0].limit_start_time =
          workTime[this.state.workHourZone].start;
        scheduleLimitTimes[0].limit_end_time =
          workTime[this.state.workHourZone].end;

        this.setState(
          {
            workTime,
            scheduleLimitTimes,
            selectedList: {},
            selectedGroup: {},
          },
          () => {
            this.getDisabledTimes();
          }
        );
      }
    });

    this.getMachineries(() => {});
    this.getTotal();

    window.addEventListener('resize', _.throttle(this.checkWindow, 500));
    window.addEventListener('resize', _.throttle(this.checkShadow, 100));
    this._scroller.current.addEventListener(
      'scroll',
      _.throttle(this.checkShadow, 100)
    );
    // マスターメニュー・機能一覧メニューの開閉の時にゲージのrender再計算を実行
    const masterNavi = document.getElementById('master-navi');
    const slideNavi = document.getElementById('func-navi--item1');
    const slideSizeObserver = new MutationObserver(() => {
      this.checkWindow();
      this.checkShadow();
    });
    const slideSizeObserverParams = {
      attributes: true,
      attributeFilter: ['class'],
      childList: false,
      characterData: false,
    };
    slideSizeObserver.observe(masterNavi, slideSizeObserverParams);
    slideSizeObserver.observe(slideNavi, slideSizeObserverParams);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.clearFlag === true) {
      this.clearFlag = false;
    }
    if (this.state.isTimeBarReset) {
      this.setState({ isTimeBarReset: false });
    }
    if (prevState.isScrolling !== this.state.isScrolling) {
      this.toggleScrolling(this.state.isScrolling);
    }
    if (prevState.isConferenceMode !== this.state.isConferenceMode) {
      this.checkWindow();
      this.checkShadow();
    }
    if (!_.isEqual(prevState.machineries, this.state.machineries)) {
      this.checkWindow();
      this.checkShadow();
    }
    if (prevState.loadingDisabledTimes !== this.state.loadingDisabledTimes) {
      this.checkWindow();
      this.checkShadow();
    }
    if (prevState.innerWidth !== this.state.innerWidth) {
      this.checkShadow();
    }
  }

  componentWillUnmount() {
    EventMg.deleteEvent(MY_EVENT.LOAD_MACHINERY_USES_DATA);
    window.removeEventListener('resize', _.throttle(this.checkShadow, 100));
    window.removeEventListener('resize', _.throttle(this.checkWindow, 500));
    this._scroller.current.removeEventListener(
      'scroll',
      _.throttle(this.checkShadow, 100)
    );
  }

  toggleScrolling = isScrolling => {
    if (isScrolling) {
      window.addEventListener('mousemove', this.onMouseMove);
      window.addEventListener('mouseup', this.onMouseUp);
    } else {
      window.removeEventListener('mousemove', this.onMouseMove);
      window.removeEventListener('mouseup', this.onMouseUp);
    }
  };

  onMouseMove = event => {
    if (this.state.isScrolling) {
      const { clientX, scrollLeft } = this.state;
      const scroller = this._scroller.current;
      scroller.scrollLeft = scrollLeft + clientX - event.clientX;
      this.checkShadow();
    }
  };

  onMouseUp = () => {
    window.removeEventListener('mousemove', this.onMouseMove);
    this.setState({
      isScrolling: false,
      scrollLeft: 0,
      clientX: 0,
    });
  };

  onMouseDown = event => {
    const { scrollLeft } = this._scroller.current;
    this.setState({
      isScrolling: true,
      scrollLeft,
      clientX: event.clientX,
    });
  };

  /**
   * 横スクロールヒント用の影チェック
   *
   */
  checkShadow = () => {
    const scroller = this._scroller.current;
    if (_.isNull(scroller) || _.isNull(this._rightTable.current)) {
      return;
    }
    if (
      this.state.total === 0
      // || LocalStorageService.getItem('is_conference') === CONFERENCE_MODE.on.key
    ) {
      return this._rightTable.current.classList.add('no-shadow');
    }
    // 端数が出る場合があるので判定を1緩める
    if (
      scroller.scrollWidth <=
      1 + scroller.scrollLeft + scroller.offsetWidth
    ) {
      this._rightTable.current.classList.add('no-shadow');
    } else {
      this._rightTable.current.classList.remove('no-shadow');
    }
  };

  checkWindow = () => {
    if (!_.isNull(this.innerWindow.current)) {
      const innerWidth = this.innerWindow.current.offsetWidth;
      this.setState({ innerWidth });
    }
  };

  // 24時間内に設定する
  convertTime24 = time => {
    return parseInt(time.split(':')[0]) >= 24
      ? `${parseInt(time.split(':')[0]) - 24}:${time.split(':')[1]}`
      : time;
  };

  /**
   * 検索フォーム開閉
   */
  handleFormOpen = () => {
    this.setState({ isOpened: !this.state.isOpened });
  };

  /**
   * 検索条件クリア
   */
  clearConditions = () => {
    // 連打防止
    if (this.state.isLoading) {
      return;
    }
    this.clearFlag = true;
    const SearchDropdown = document.querySelectorAll('.SearchDropdown');
    _.each(SearchDropdown, dropDown => {
      dropDown.value = '';
    });
    this.setState(
      {
        machineries: {},
        machineryLoaded: false,
        searchConditions: _.cloneDeep(paramsDefault),
        tempSearchConditions: _.cloneDeep(paramsDefault),
        refresh: true,
        selectedGroup: {},
        selectedList: {},
        machinerySortedIds: [],
        isLoading: true,
      },
      () => {
        this.getMachineries(() => {});
        this.getTotal();
      }
    );
  };

  /**
   * 禁止時間帯追加
   */
  addLimitTime = (init = false) => {
    let disabledTimes = this.state.disabledTimes;
    if (init) {
      disabledTimes = [];
    }
    const workTime = this.state.workTime;
    const disabledTime = {
      schedule_type: SCHEDULE_TYPES.machinery.id,
      target_id: '',
      limit_start_date: this.state.fromDate,
      limit_start_time: workTime[this.state.workHourZone].start,
      limit_end_time: workTime[this.state.workHourZone].end,
    };
    disabledTimes.push(disabledTime);
    this.setState({ disabledTimes });
  };

  /**
   * 禁止時間帯設定
   */
  setLimitTime = (e, key) => {
    const selectedIndex = e.target.selectedIndex;
    const selected = e.target.options[selectedIndex];
    const selectedDate = selected.getAttribute('data-select');
    const target = moment(selectedDate);
    let disabledTimes = _.cloneDeep(this.state.disabledTimes);
    const name = e.target.name;
    const value = e.target.value;
    disabledTimes[key][name] = value;
    disabledTimes[key]['changed'] = true;
    if (name === 'limit_start_time') {
      if (!disabledTimes[key].limit_end_time) {
        disabledTimes[key].limit_end_time = target
          .add(15, 'minutes')
          .format('HH:mm:ss');
      } else {
        const endSelect = document.getElementById(
          `machinery-uses-limit-end-time-${key}`
        );
        const endIndex = endSelect.selectedIndex;
        const endSelected = endSelect.options[endIndex];
        const end = moment(endSelected.getAttribute('data-select'));
        if (end.isSameOrBefore(target)) {
          disabledTimes[key].limit_end_time = target
            .add(15, 'minutes')
            .format('HH:mm:ss');
        }
      }
    } else if (name === 'limit_end_time') {
      if (!disabledTimes[key].limit_start_time) {
        disabledTimes[key].limit_start_time = target
          .add(-15, 'minutes')
          .format('HH:mm:ss');
      } else {
        const startSelect = document.getElementById(
          `machinery-uses-limit-start-time-${key}`
        );
        const startIndex = startSelect.selectedIndex;
        const startSelected = startSelect.options[startIndex];
        const start = moment(startSelected.getAttribute('data-select'));
        if (start.isSameOrAfter(target)) {
          disabledTimes[key].limit_start_time = target
            .add(-15, 'minutes')
            .format('HH:mm:ss');
        }
      }
    }
    this.setState({ disabledTimes });
  };

  /**
   * 禁止時間帯追加項目削除
   * @param key {int}
   */
  removeLimitTime = key => {
    let disabledTimes = this.state.disabledTimes;
    const deleteScheduleLimitTimeIds = [
      ...this.state.deleteScheduleLimitTimeIds,
    ];
    let times = [];
    _.each(disabledTimes, (disabledTime, index) => {
      if (index !== key) {
        times.push(disabledTime);
      } else {
        if (!_.isUndefined(disabledTime.id)) {
          deleteScheduleLimitTimeIds.push(disabledTime.id);
        }
      }
    });
    this.setState({ disabledTimes: times, deleteScheduleLimitTimeIds });
  };

  /**
   * ダイアログ表示・非表示
   * @params key {string}
   */
  handleVisible = (key, approvalMessage, oneMachineryId) => {
    if (!_.isUndefined(oneMachineryId) && !_.isNull(oneMachineryId)) {
      this.setState({
        one_machinery_id: oneMachineryId,
        one_machinery_flag: true,
      });
    } else {
      this.setState({ one_machinery_flag: false });
    }
    const modalState = {};
    const visible = !this.state.modalVisible[key];
    modalState[key] = visible;
    if (key === 'disableTime' || key === 'success') {
      this.getDisabledTimes();
    }
    if (!_.isUndefined(approvalMessage)) {
      if (approvalMessage === '') {
        modalState[key] = !visible;
      } else {
        modalState['approvalMessage'] = approvalMessage;
        modalState['approvalTitle'] = this.state.modalVisible.approvalTitle;
      }
    }
    this.setState({ modalVisible: modalState, deleteScheduleLimitTimeIds: [] });
  };

  getDisabledTimes() {
    this.setState(
      {
        loadingDisabledTimes: true,
      },
      () => {
        ScheduleLimitTimeService.list(this.state.fieldId, {
          schedule_type: SCHEDULE_TYPES.machinery.id,
          isQuiet: true,
        }).then(response => {
          if (response.result) {
            if (response.data.total >= 0) {
              let disabledTimes = [];
              _.each(
                response.data.entities.schedule_limit_times,
                schedule_limit_time => {
                  disabledTimes.push({
                    id: schedule_limit_time.id,
                    update: true,
                    changed: false,
                    schedule_type: SCHEDULE_TYPES.machinery.id,
                    target_id: schedule_limit_time.target_id,
                    target_name: schedule_limit_time.target_name,
                    limit_start_date: this.state.fromDate,
                    limit_start_time: schedule_limit_time.limit_start_time,
                    limit_end_time: schedule_limit_time.limit_end_time,
                  });
                }
              );
              this.setState({ disabledTimes, loadingDisabledTimes: false });
            }
          }
        });
      }
    );
  }

  /**
   * 検索条件(保存用)セット（単数）
   */
  setSingleCondition = e => {
    this.setState(prevState => ({
      tempSearchConditions: {
        ...prevState.tempSearchConditions,
        [e.target.name]: e.target.value,
      },
    }));
  };

  /**
   * 検索条件セット
   */
  setSearchCondition = () => {
    // 連打防止
    if (this.state.isLoading) {
      return;
    }
    const searchConditions = _.cloneDeep(this.state.tempSearchConditions);
    this.setState(
      {
        machineries: {},
        machineryLoaded: false,
        selectedGroup: {},
        selectedList: {},
        searchConditions,
        machinerySortedIds: [],
        isLoading: true,
      },
      () => {
        this.getMachineries(() => {});
        this.getTotal();
      }
    );
  };

  /**
   * 検索条件(保存用)セット（複数）
   * @parmas name {string}
   * @parmas selected {object} // 選択した値
   */
  setMultiCondition = (name, selected) => {
    this.setState(prevState => ({
      tempSearchConditions: {
        ...prevState.tempSearchConditions,
        [name]: selected,
      },
    }));
  };

  /**
   * 禁止時間帯機材セット
   * @parmas key {int}
   * @parmas selected {object} // 選択した値
   */
  setDisableMachineries = (key, selected) => {
    let disabledTimes = _.cloneDeep(this.state.disabledTimes);
    disabledTimes[key].target_id = selected;
    disabledTimes[key].changed = true;
    this.setState({ disabledTimes });
  };

  /**
   * 機材予定単一選択
   * @params machineryId {int}
   * @params selected {boolean} // 選択済み判定
   */
  handleSelectedRow = (e, machineryId, selected) => {
    const selectedList = { ...this.state.selectedList };
    const selectedGroup = { ...this.state.selectedGroup };
    const machineryUsesId = parseInt(e.target.value, 10);
    if (selected) {
      if (_.isUndefined(selectedList[machineryId])) {
        selectedList[machineryId] = [];
      }
      if (!selectedList[machineryId].includes(machineryUsesId)) {
        selectedList[machineryId].push(machineryUsesId);
      }
      // 選択した項目が所属するグループが全チェックされているなら
      // グループ項目をチェックする
      if (
        selectedList[machineryId].length ===
        this.state.machineries[machineryId].machineryUses.length
      ) {
        selectedGroup[machineryId] = true;
      }
    } else {
      _.remove(selectedList[machineryId], machineryUses => {
        return parseInt(machineryUses) === machineryUsesId;
      });
      selectedGroup[machineryId] = false;
    }
    this.setState({
      selectedList,
      selectedGroup,
    });
  };

  /**
   * 取得したデータ全選択
   * @params selected {boolean} 選択したかどうか判定
   */
  handleSelectedAll = selected => {
    let selectedList = {};
    let selectedGroup = {};
    if (selected) {
      _.each(this.state.machineries, machinery => {
        selectedList[machinery.id] = [];
        selectedGroup[machinery.id] = true;
        _.each(machinery.machineryUses, machineryUse =>
          selectedList[machinery.id].push(parseInt(machineryUse.id))
        );
      });
    }

    this.setState({
      selectedGroup,
      selectedList,
    });
  };

  /**
   * グループ単位で選択
   * @params checked {boolean} // 選択判定
   * @params machineryId {int}
   */
  handleSelectedGroup = (checked, machineryId) => {
    let selectedList = this.state.selectedList;
    let selectedGroup = this.state.selectedGroup;
    const machineryUses = this.state.machineries[machineryId].machineryUses;

    if (checked) {
      if (_.isUndefined(selectedList[machineryId])) {
        selectedList[machineryId] = [];
      }
      _.each(machineryUses, machineryUse => {
        const machineryUsesId = parseInt(machineryUse.id, 10);
        if (!selectedList[machineryId].includes(machineryUsesId)) {
          selectedList[machineryId].push(machineryUsesId);
        }
      });
      selectedGroup[machineryId] = true;
    } else {
      selectedList[machineryId] = [];
      selectedGroup[machineryId] = false;
    }

    this.setState({
      selectedGroup,
      selectedList,
    });
  };

  /**
   * 時間の更新
   * @params data {object}
   * @params useWorkTime {object}
   */
  handleGageUpdate(data, useWorkTime) {
    if (
      data.use_start_time === useWorkTime.start &&
      data.use_end_time === useWorkTime.end
    ) {
      return;
    }
    let params = {
      field_id: this.state.fieldId,
      machinery_id: data.machinery_id,
      use_date: data.use_date,
      today_receipt_no: data.today_receipt_no,
      use_start_time: moment(
        this.convertTime24(useWorkTime.start),
        'HH:mm'
      ).format('HH:mm:ss'),
      use_end_time: moment(this.convertTime24(useWorkTime.end), 'HH:mm').format(
        'HH:mm:ss'
      ),
      work_hour_zone: this.state.workHourZone,
    };
    let promise = new Promise(resolve => {
      MachineryUseService.update(this.state.fieldId, data.id, params)
        .then(response => {
          if (response.result) {
            let machineries = this.state.machineries;
            _.each(
              machineries[data.machinery_id].machineryUses,
              machineryUse => {
                if (machineryUse.id === data.id) {
                  machineryUse.use_start_time = useWorkTime.start;
                  machineryUse.use_end_time = useWorkTime.end;
                }
              }
            );
            EventMg.trigger(MY_EVENT.LOAD_MACHINERY_USES_DATA);
            this.setState({ machineries });
            resolve(response.result);
          } else {
            //エラーメッセージを表示する
            alert('時間の更新に失敗しました。');
          }
        })
        .catch(error => {
          if (error.status === 403) {
            this.events.modal.handleVisible('timeForbiddenError');
            this.setState({ isTimeBarReset: true });
          }
        });
    });
    return promise;
  }

  /**
   * グループ単位の選択があるか判定
   * @params machineryId {int}
   * @return boolean
   */
  isSelectedGroup(machineryId) {
    return this.state.selectedGroup[machineryId];
  }

  /**
   * 日付セット
   */
  setDate = (name, date) => {
    let state = this.state;
    if (state[name] !== date) {
      state[name] = date;
      this.setState(state);
    }
  };

  /**
   * 機材予定の選択判定
   * @params machineryId {int}
   * @params machineryUseId {int}
   */
  isSelected(machineryId, machineryUseId) {
    let bool = false;
    if (
      _.indexOf(this.state.selectedList[machineryId], machineryUseId) !== -1
    ) {
      bool = true;
    }
    return bool;
  }

  getMachineriesParams(offset) {
    let params = {
      field_id: this.state.fieldId,
      use_date_from: this.state.fromDate,
      use_date_to: this.state.toDate,
      work_hour_zone: this.state.workHourZone,
      limit: LIST_LIMIT.MACHINERY.PARENT,
      offset,
      isQuiet: true,
    };

    params = _.merge(params, this.state.searchConditions);
    return params;
  }

  convertMachineriesToStateData(machineryList) {
    let machineries = {};
    let machinerySortedIds = [];
    _.each(machineryList, machinery => {
      machineries[machinery.id] = machinery;
      if (!machinerySortedIds.includes(machinery.id)) {
        machinerySortedIds.push(machinery.id);
      }
    });

    return { machineries, machinerySortedIds };
  }

  /**
   * 機材マスタ取得
   */
  getMachineries(notify) {
    if (this.state.machineryLoaded) {
      notify();
      this.setState({ isLoading: false });
      return;
    }

    // 大項目:グループ項目
    const params = this.getMachineriesParams(_.size(this.state.machineries));
    MachineryService.listForMachineryUses(this.state.fieldId, params).then(
      response => {
        if (response.result) {
          const data = response.data.entities.machineries;
          if (_.isEmpty(data)) {
            this.setState({ machineryLoaded: true });
          } else {
            let machineries = this.state.machineries;
            let machinerySortedIds = [...this.state.machinerySortedIds];
            _.each(data, machinery => {
              machineries[machinery.id] = machinery;
              if (!machinerySortedIds.includes(machinery.id)) {
                machinerySortedIds.push(machinery.id);
              }
            });
            // 小項目:各行項目
            this.getMachineryUses(machineries);
            this.setState({ machineryLoaded: false, machinerySortedIds });
          }
        }
        this.setState({ isLoading: false });
        notify();
      }
    );
  }

  getMachineriesForReload = async offset => {
    const params = this.getMachineriesParams(offset);
    const response = await MachineryService.listForMachineryUses(
      this.state.fieldId,
      params
    );
    if (response.result) {
      return {
        items: response.data.entities.machineries,
        totalCount: response.data.total,
      };
    } else {
      return {
        items: [],
        totalCount: 0,
      };
    }
  };

  /**
   * 指定されたMachineryIDで配列からデータを取得する
   * 注）this.state.machineries[xxx]とやっているところは、後に置き換えた方がいいかも
   * @param {*} id MachineryID
   */
  getMachineryById(id) {
    const machinery = this.state.machineries[id] || {};
    if (_.isEmpty(machinery)) {
      console.warn(
        `指定されたID(machinery id)[${id}]に該当するデータ存在しません（本来なら出てはいけないのでロジック要チェック）`
      );
    }
    return machinery;
  }

  getMachineryUsesParams(machineryId, offset) {
    let params = {
      field_id: this.state.fieldId,
      use_date_from: this.state.fromDate,
      use_date_to: this.state.toDate,
      machinery_id: [machineryId],
      work_hour_zone: this.state.workHourZone,
      limit: LIST_LIMIT.MACHINERY.CHILD,
      offset,
    };

    let searchConditions = _.cloneDeep(this.state.searchConditions);
    delete searchConditions.machinery_id;
    params = _.merge(params, searchConditions);

    return params;
  }

  /**
   * 機材予定取得
   * @params machineries {object}
   */
  getMachineryUses(machineries) {
    _.each(machineries, machinery => {
      if (!machinery.machineryUses) {
        const params = this.getMachineryUsesParams(
          machinery.id,
          _.size(machinery.machineryUses)
        );
        MachineryUseService.list(this.state.fieldId, params).then(response => {
          if (response.result) {
            const machineryUses = response.data.entities.machinery_uses;
            const machineryUseLoaded =
              response.data.total <= LIST_LIMIT.MACHINERY.CHILD;
            machineries[machinery.id] = _.assign(machinery, {
              machineryUseLoaded,
              machineryUses,
            });
            this.setState({ machineries }, () => {
              this.checkShadow();
            });
          }
        });
      }
    });
  }

  getMachineryUsesForReload = async (machineryId, offset) => {
    const params = this.getMachineryUsesParams(machineryId, offset);

    // 小項目の検索
    const response = await MachineryUseService.list(this.state.fieldId, params);
    if (response.result) {
      return {
        items: response.data.entities.machinery_uses,
        totalCount: response.data.total,
      };
    } else {
      return {
        items: [],
        totalCount: 0,
      };
    }
  };

  async reLoad() {
    const loadedMaxCount = _.size(this.state.machineries);
    const {
      allItems: allMachineries,
      totalCount: machineriesTotalCount,
    } = await ReloadHelper.takeLoad(
      this.getMachineriesForReload,
      loadedMaxCount,
      this.state.machineryLoaded
    );
    this.setState({
      machineryLoaded: _.size(allMachineries) >= machineriesTotalCount,
    });

    const newMachineries = await Promise.all(
      _.map(allMachineries, async machinery => {
        const loadMachineriesUsesUnit = offset =>
          this.getMachineryUsesForReload(machinery.id, offset);
        const currentMachinery = this.state.machineries[machinery.id] || {};
        const maxMachineryUses = _.size(currentMachinery.machineryUses);
        const isLoadComp = currentMachinery.machineryUseLoaded || false;
        const {
          allItems: machineryUses,
          totalCount: machineryUsesTotalCount,
        } = await ReloadHelper.takeLoad(
          loadMachineriesUsesUnit,
          maxMachineryUses,
          isLoadComp
        );

        const machineryUseLoaded =
          _.size(machineryUses) >= machineryUsesTotalCount;
        return {
          ...machinery,
          machineryUseLoaded,
          machineryUses,
        };
      })
    );

    const {
      machineries,
      machinerySortedIds,
    } = this.convertMachineriesToStateData(newMachineries);
    // machineries のデータ構造は次のようになる
    //  {GroupID1: { machineryUses: [ItemID1, ItemID2, ...] }, GroupID2: ... }
    // machinerySortedIds のデータ構造は次のようになる
    //  [GroupID1, GroupID2, ...]

    const selectedList = _.cloneDeep(this.state.selectedList);
    const selectedGroup = _.cloneDeep(this.state.selectedGroup);
    // this.state.selectedList のデータ構造は次のようになる
    // { GroupID1: [ItemID1, ItemID2, ...], GroupID2: ... }

    // BLDE_V2-16335 の対応
    // 選択リスト(selectedList)内に入っているものが、
    // データ(machineries)内に含まれていれば残す。
    // 既に削除済みの場合には削除する
    for (let groupId of Object.keys(selectedList)) {
      selectedList[groupId] = selectedList[groupId].filter(item => {
        if (_.isUndefined(machineries[groupId])) {
          return false;
        }
        return machineries[groupId].machineryUses.includes(item);
      });
      if (_.size(selectedList[groupId]) === 0) {
        selectedGroup[groupId] = false;
      }
    }

    this.setState({
      machineries,
      machinerySortedIds,
      selectedList,
      selectedGroup,
    });
  }

  /**
   * 総数取得
   */
  getTotal() {
    let params = {
      // 日付(from)
      use_date_from: this.state.fromDate,
      // 日付(to)
      use_date_to: this.state.toDate,
      // 勤務時間帯種別 1:昼間、2:夜間、3:深夜
      work_hour_zone: this.state.workHourZone,
    };

    params = _.merge(params, this.state.searchConditions);
    MachineryUseService.total(this.state.fieldId, params).then(response => {
      if (response.result) {
        this.setState({ total: response.data.total }, () => {
          this.checkShadow();
        });
      }
    });
  }

  /**
   * 機材予定追加取得
   * 「さらに表示する」機能
   * @param machineryId {int}
   */
  fetchMachineryUses(machineryId) {
    if (this.isRequestingFlag) {
      return;
    }
    this.isRequestingFlag = true;
    let machineries = this.state.machineries;

    let params = {
      field_id: this.state.fieldId,
      use_date_from: this.state.fromDate,
      use_date_to: this.state.toDate,
      work_hour_zone: this.state.workHourZone,
      machinery_id: [machineryId],
      limit: LIST_LIMIT.MACHINERY.CHILD,
      offset: _.size(machineries[machineryId].machineryUses),
    };

    let searchConditions = _.cloneDeep(this.state.searchConditions);
    delete searchConditions.machinery_id;
    params = _.merge(params, searchConditions);

    MachineryUseService.list(this.state.fieldId, params)
      .then(response => {
        if (response.result) {
          const data = response.data.entities.machinery_uses;
          _.map(data, machineryUse =>
            machineries[machineryId].machineryUses.push(machineryUse)
          );
          const machineryUseLoaded =
            _.size(machineries[machineryId].machineryUses) ===
            response.data.total;
          machineries[machineryId].machineryUseLoaded = machineryUseLoaded;

          // グループ選択を解除する
          const selectedGroup = { ...this.state.selectedGroup };
          selectedGroup[machineryId] = false;

          this.setState({ machineries, selectedGroup });
        }
      })
      .finally(() => {
        this.isRequestingFlag = false;
      });
  }

  /**
   * 承認・否認 API用パラメータ生成
   */
  createParams() {
    let params = {
      ids: [],
    };

    _.each(this.state.selectedList, machinery =>
      _.each(machinery, machineryUse => {
        params.ids.push(machineryUse);
      })
    );

    return params;
  }

  /**
   * 更新したデータでstateのmachineriesを上書き
   * @params updated {object}
   * @params approvalMessage {string} // 承認、未承認メッセージ
   */
  updatedMachineryUses(updated, approvalMessage) {
    let machineries = {};
    _.each(this.state.machineries, machinery => {
      let newList = [];
      _.each(machinery.machineryUses, machineryUse => {
        let newest = machineryUse;
        let found = _.filter(updated, { id: machineryUse.id });
        if (!_.isEmpty(found)) {
          newest = found[0];
        }
        newList.push(newest);
      });
      machineries[machinery.id] = _.assign(machinery, {
        machineryUses: newList,
      });
    });

    this.setState({
      machineries,
    });

    this.events.modal.handleVisible('approvalStatus', approvalMessage);
  }

  /**
   * 承認
   */
  approvalMachineryUses() {
    if (_.isEmpty(this.state.selectedList)) {
      this.events.modal.handleVisible('approval');
      return;
    }
    const params = this.createParams();
    this.updateApprovalFlgList(params, true, true);
  }

  /**
   * 否認
   */
  disapprovalMachineryUses() {
    if (_.isEmpty(this.state.selectedList)) {
      this.events.modal.handleVisible('disapproval');
      return;
    }
    const params = this.createParams();
    this.updateApprovalFlgList(params, false, true);
  }

  onToggleApprovalSingle = machineryUse => {
    if (!isTargetRoleId(USER_ROLES_IDS.PRIME_COMPANY, this.state.roleId)) {
      return;
    }
    this.setState({ selectedApprovalMachineryUse: machineryUse });
    if (machineryUse.approval_flag === APPROVAL_STATUS.unapproved.id) {
      this.events.modal.handleVisible('approvalSingle');
    } else {
      this.events.modal.handleVisible('disapprovalSingle');
    }
  };

  updateApprovalFlgSingle = () => {
    const { selectedApprovalMachineryUse } = this.state;
    const isApproval =
      selectedApprovalMachineryUse.approval_flag ===
      APPROVAL_STATUS.unapproved.id;
    const params = {
      ids: [selectedApprovalMachineryUse.id],
    };

    this.updateApprovalFlgList(params, isApproval, false);
  };

  updateApprovalFlgList = onceAsyncRequest(
    async (params, isApproval, isClearSelectedList) => {
      const updateF = isApproval
        ? MachineryUseService.approvalList
        : MachineryUseService.disapprovalList;
      await updateF(this.state.fieldId, params).then(response => {
        if (response.result === false) {
          return;
        }

        // 承認/承認解除結果ダイヤログのタイトル
        let approvalTitle = `${SCHEDULE_TYPES.machinery.name}予定の承認${
          isApproval ? '' : '解除'
        }${response.message.includes('完了') ? '完了' : ''}`;
        this.setState({
          modalVisible: {
            ...this.state.modalVisible,
            approvalTitle,
          },
        });

        this.updatedMachineryUses(
          response.data.entities.machinery_uses,
          response.message
        );

        if (isClearSelectedList) {
          this.setState({
            selectedList: {},
            selectedGroup: {},
          });
        }
      });
    }
  );

  handleShowCopyDialog = () => {
    let includeLinkedIchiPlus = false;
    let includeNotLinkedIchiPlus = false;
    _.each(this.state.selectedList, (value, key) => {
      if (_.size(value)) {
        const externalSystemMachineries = _.get(
          this.state.machineries,
          `${key}.external_system_machineries`
        );
        if (
          _.some(externalSystemMachineries, {
            external_system_type: EXTERNAL_SYSTEM_TYPE.ICHI_PLUS,
          })
        ) {
          includeLinkedIchiPlus = true;
        } else {
          includeNotLinkedIchiPlus = true;
        }
      }
    });
    if (includeLinkedIchiPlus) {
      //allow copy machinery uses that not linked IchiPlus
      return dialogLoader.show(CopyMachineryUsesIchiPlusWarning, {
        message: messageUtility.getMessage(
          includeNotLinkedIchiPlus ? 'W-001-306' : 'W-001-305'
        ),
        callback: {
          close: () => {
            dialogLoader.close();
            if (includeNotLinkedIchiPlus) {
              this.events.modal.handleVisible('copy');
            }
          },
        },
      });
    }
    this.events.modal.handleVisible('copy');
  };

  /**
   * 選択項目をコピー
   *  コピー先の日付を選択
   */
  copyMachineryUses = onceAsyncRequest(async () => {
    if (_.isEmpty(this.state.selectedList)) {
      this.events.modal.handleVisible('copy');
    } else {
      let params = {
        ids: [],
      };

      _.each(this.state.selectedList, machinery =>
        _.each(machinery, MachineryUse => {
          params.ids.push(MachineryUse);
        })
      );
      params.use_date = this.state.use_date;

      await MachineryUseService.copy(this.state.fieldId, params)
        .then(response => {
          if (response.message) {
            this.events.modal.handleVisible('copy');
            dialogLoader.show(ErrorDialog, {
              message: response.message,
              callback: {
                close: () => {
                  dialogLoader.close();
                },
              },
            });
            return;
          }

          if (response.result) {
            this.setState(
              {
                machineries: {},
                machineryLoaded: false,
                searchConditions: _.cloneDeep(paramsDefault),
                tempSearchConditions: _.cloneDeep(paramsDefault),
                refresh: true,
                selectedList: {},
                selectedGroup: {},
                machinerySortedIds: [],
                isLoading: true,
              },
              () => {
                this.events.modal.handleVisible('copy');
                this.getMachineries(() => {});
                this.getTotal();
              }
            );
            if (response.data.entities.manager_user_id_reset) {
              this.events.modal.handleVisible('copyNotComplete');
            }
          }
        })
        .catch(error => {
          if (error.status === 403) {
            this.events.modal.handleVisible('copyForbiddenError');
          }
        });
    }
  });

  /**
   * エラーメッセージ ダイアログ
   */
  showErrorDialog(message) {
    dialogLoader.show(ErrorDialog, {
      message,
      callback: {
        close: () => {
          dialogLoader.close();
        },
      },
    });
  }

  /**
   * 禁止時間帯設定
   */
  updateDisabledTimes() {
    const { disabledTimes, fieldId } = this.state;
    _.map(disabledTimes, disabledTime => {
      if (!_.isNull(disabledTime.target_id) || disabledTime.target_id !== '') {
        // 禁止時間が変更されてない場合
        if (disabledTime.update === true && disabledTime.changed === false) {
          return;
        }
        if (disabledTime.update === true && disabledTime.changed === true) {
          disabledTime.isQuiet = true;
          ScheduleLimitTimeService.update(
            fieldId,
            disabledTime.id,
            disabledTime
          ).then(response => {
            if (response.result) {
              const newTimes = _.map(disabledTimes, time => {
                return time.id === disabledTime.id ? disabledTime : time;
              });
              this.setState({
                disabledTimes: newTimes,
              });
            } else {
              this.showErrorDialog(response.message); // エラーメッセージ
              setTimeout(() => {
                this.getDisabledTimes();
              }, 1000);
            }
          });
        } else {
          ScheduleLimitTimeService.create(fieldId, disabledTime).then(
            response => {
              if (response.result) {
                return;
              } else {
                this.showErrorDialog(response.message); // エラーメッセージ
                setTimeout(() => {
                  this.getDisabledTimes();
                }, 1000);
              }
            }
          );
        }
      }
    });

    const deleteScheduleLimitTimeIds = this.state.deleteScheduleLimitTimeIds;
    if (_.size(deleteScheduleLimitTimeIds) > 0) {
      const params = {
        schedule_type: SCHEDULE_TYPES.machinery.id,
        ids: deleteScheduleLimitTimeIds,
      };
      ScheduleLimitTimeService.destroy(this.state.fieldId, params).then();
    }

    this.setState(
      {
        machineries: {},
        machineryLoaded: false,
        searchConditions: _.cloneDeep(paramsDefault),
        tempSearchConditions: _.cloneDeep(paramsDefault),
        refresh: true,
        selectedList: {},
        selectedGroup: {},
        machinerySortedIds: [],
        isLoading: true,
        modalVisible: {
          disableTime: false,
        },
      },
      () => {
        this.getMachineries(() => {});
        this.getTotal();
      }
    );
  }

  /**
   * 禁止時間帯クリア
   */
  destroyScheduleLimitTimes() {
    ScheduleLimitTimeService.destroy(this.state.fieldId, {
      schedule_type: SCHEDULE_TYPES.machinery.id,
      ids: [],
    }).then(response => {
      if (response.status === 200 || response.status === 0) {
        this.events.modal.handleVisible('success');
        this.getMachineries(() => {});
        this.getTotal();
      } else {
        this.events.modal.handleVisible('failure');
      }
    });
  }

  /**
   * 新規作成ボタンを表示するかどうか
   * @return boolean
   */
  isShowRegisterButton() {
    if (this.state.viewOnlyFlag) {
      return false;
    }

    // 選択されている行があれば「選択項目をコピー」を表示するので新規作成は表示しない
    return !this.someSelectedList();
  }

  /**
   * データを選択しているかどうか判定
   * @return boolean
   */
  someSelectedList() {
    return _.some(this.state.selectedList, item => !_.isEmpty(item));
  }

  /**
   * 編集画面へ遷移
   * @param machineryUse {object}
   */
  editRow = (e, machineryUse) => {
    if (e.target.closest('[data-unlink]')) {
      return;
    }
    // 左右スクロールした場合遷移しない
    if (this.state.clientX !== e.clientX) {
      return;
    }
    _slideLoader.show(
      'MachineryUseRegister',
      { state: { id: machineryUse.id } },
      this.props.vw
    );
  };

  /**
   * 帳票出力
   */
  callDocurain() {
    if (this.state.calling) {
      return;
    }
    this.setState({ calling: true });
    const date = this.state.fromDate;
    let param = { ...this.state.searchConditions };
    if (this.state.one_machinery_flag) {
      param.machinery_id = this.state.one_machinery_id
        ? [this.state.one_machinery_id]
        : [];
    }
    param.field_id = this.state.fieldId;
    param.work_hour_zone = this.state.workHourZone;
    param.target_date = moment(date).format('YYYY-MM-DD');
    param.file_code = FILE_CODE.PDF;
    param.report_code = 13;
    const reportName = ReportNames.AllMachineryInstruction;
    const newTab = window.open('/LayoutPrint', '_blank');
    PrintService.printReportByReportName(reportName, param)
      .then(response => {
        if (_.isUndefined(response.message)) {
          const pdfUrl = response.pdf_s3_url;
          PrintService.getHeaderReponseURL(pdfUrl.head_pdf_url)
            .then(responseS3AWS => {
              if (responseS3AWS.status === STATUS_CODE.ok) {
                const fileName = PrintService.makeReportFileName(
                  reportName,
                  param.file_code,
                  date
                );
                const blob = PrintUtility.convertBase64ToBlob(
                  response.data,
                  'application/pdf'
                );
                PrintUtility.printBlob(blob, fileName, param.file_code);
                newTab.location.href = pdfUrl.get_pdf_url;
              }
            })
            .catch(() => {
              newTab.close();
              this.events.modal.handleVisible('documentsError');
              this.setState({
                apiMessage: messageUtility.getMessage('E-001-401'),
              });
            });
        } else {
          newTab.close();
          this.events.modal.handleVisible('documentsError');
          this.setState({ apiMessage: response.message });
        }
        this.setState({ calling: false });
      })
      .catch(error => {
        newTab.close();
        this.setState({ calling: false });
        alert(error);
      });
    param.machinery_id = [];
  }

  /**
   * 全て選択されているか確認
   */
  checkAllSelected(selectedList = this.state.selectedList) {
    let machineriesCnt = 0;
    _.each(this.state.machineries, machinery => {
      if (_.has(machinery, 'machineryUses')) {
        machineriesCnt = machineriesCnt + machinery.machineryUses.length;
      }
    });
    let selectedCnt = 0;
    _.each(selectedList, machinery => {
      selectedCnt = selectedCnt + machinery.length;
    });
  }

  /**
   * 詳細項目の件数を取得する
   */
  subItemCount(machineryId) {
    const { machineries } = this.state;
    // this.state.machineries は読み込みだけしか使っていない

    if (!_.isArray(machineries[machineryId].machineryUses)) {
      return 0;
    }
    return machineries[machineryId].machineryUses.length;
  }

  /**
   * 「表示項目を全て選択」のために全チェックかどうか確認
   */
  getSelectAll() {
    const validGroups = _.filter(this.state.selectedGroup, function(value) {
      return value === true;
    });
    if (
      Object.keys(validGroups).length ===
      Object.keys(this.state.machineries).length
    ) {
      return true;
    } else {
      return false;
    }
  }

  render() {
    this.checkAllSelected();
    const isConferenceMode =
      SessionStorageService.getItem('is_conference') === CONFERENCE_MODE.on.key;
    if (isConferenceMode !== this.state.isConferenceMode) {
      this.setState({ isConferenceMode });
    }
    const slide = urlParamManager.getSlideParam();
    return (
      <div id='main' className='main MachineryUses'>
        {slide[0] === '0' && ( // リロード時他ページのtitleを上書きする問題の対策
          <Helmet>
            <title>{HEADER_CONSTANTS.conference} - 機材予定一覧</title>
          </Helmet>
        )}
        <ConferencePageHeader title='機材予定一覧' />
        <div id='scroll-parent' className='main__body'>
          <div className='equipment-schedulelist' ref={this.innerWindow}>
            <div className='equipment-schedulelist__header'>
              <ul className='btn-menu'>
                <li className='btn-menu__item'>
                  <button
                    id='open-slide-view'
                    style={
                      this.isShowRegisterButton()
                        ? { display: 'block' }
                        : { display: 'none' }
                    }
                    className='btn'
                    onClick={() => {
                      _slideLoader.show(
                        'MachineryUseRegister',
                        this.FormNew,
                        this.props.vw
                      );
                    }}
                  >
                    新規作成
                  </button>
                  {!isConferenceMode && (
                    <button
                      id='open-slide-view'
                      style={
                        this.someSelectedList()
                          ? { display: 'block' }
                          : { display: 'none' }
                      }
                      className='btn'
                      onClick={this.handleShowCopyDialog}
                    >
                      選択項目をコピー
                    </button>
                  )}
                </li>
                <PrimeContractorToggle>
                  {!isConferenceMode && (
                    <React.Fragment>
                      <li className='btn-menu__item sm--hidden md--hidden'>
                        <div className='segment-line' />
                      </li>
                      <li className='btn-menu__item'>
                        <button
                          id='modal-open-confirm-selected'
                          className={`btn--effective ${
                            this.someSelectedList() ? '' : 'btn--disabled'
                          }`}
                          onClick={() =>
                            this.events.modal.handleVisible('approval')
                          }
                          disabled={!this.someSelectedList()}
                        >
                          選択項目を承認
                        </button>
                      </li>
                      <li className='btn-menu__item'>
                        <button
                          id='modal-open-confirm-deselected'
                          className={`btn--negative ${
                            this.someSelectedList() ? '' : 'btn--disabled'
                          }`}
                          onClick={() =>
                            this.events.modal.handleVisible('disapproval')
                          }
                          disabled={!this.someSelectedList()}
                        >
                          選択項目の承認解除
                        </button>
                      </li>
                    </React.Fragment>
                  )}
                </PrimeContractorToggle>
                <li className='btn-menu__item --fx-auto sm--hidden' />
                <li className='btn-menu__item sm--hidden'>
                  <button
                    id='modal-open-disable-time'
                    className='btn--sub'
                    style={
                      isPrimaryCompanyRoleId(this.state.roleId)
                        ? { display: 'block' }
                        : { display: 'none' }
                    }
                    onClick={() =>
                      this.events.modal.handleVisible('disableTime')
                    }
                  >
                    禁止時間帯設定
                  </button>
                </li>
                <li className='btn-menu__item sm--hidden'>
                  <button
                    id='modal-open-document'
                    className='btn--sub'
                    onClick={() => this.events.modal.handleVisible('documents')}
                  >
                    印刷
                  </button>
                </li>
              </ul>
            </div>
            <MachineryUsesSearchForm
              total={this.state.total}
              isOpened={this.state.isOpened}
              callbacks={this.events.search}
              clearFlag={this.clearFlag}
              tempSearchConditions={this.state.tempSearchConditions}
            />
            <div className='equipment-schedulelist__list-header'>
              <ul className='btn-menu'>
                {!isConferenceMode && (
                  <React.Fragment>
                    <li className='btn-menu__item'>
                      <button
                        id='btn-check-all'
                        className={
                          !this.getSelectAll()
                            ? 'btn--stay'
                            : 'btn--sub disabled'
                        }
                        onClick={() =>
                          this.events.table.handleSelectedAll(true)
                        }
                      >
                        表示項目を全て選択
                      </button>
                    </li>
                    <li className='btn-menu__item'>
                      <button
                        id='btn-uncheck-all'
                        className={
                          this.someSelectedList()
                            ? 'btn-text'
                            : 'btn-text--sub disabled'
                        }
                        disabled={!this.someSelectedList()}
                        onClick={() =>
                          this.events.table.handleSelectedAll(false)
                        }
                      >
                        選択中の項目を解除
                      </button>
                    </li>
                    {this.state.loadingDisabledTimes === true &&
                      this.state.modalVisible.disableTime === false && (
                        <ClipLoader size={24} color={'#cccccc'} />
                      )}
                  </React.Fragment>
                )}
              </ul>
              <div className='equipment-schedulelist__list-description'>
                <div className='gage-sample'>
                  <div className='gage-sample__item'>
                    <div className='gage-sample__label'>
                      <span className='label'>スポット</span>
                    </div>
                    <div className='gage-sample__element'>
                      <div className='gage--spot'>
                        <div className='gage__bar' />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='gage-table'>
              <div
                className='gage-table__scroller'
                style={{
                  // overflow: isConferenceMode ? 'visible' : 'visible',
                  overflow: 'visible',
                }}
              >
                <div
                  className='gage-table__left'
                  style={{
                    minWidth: _.ceil(this.state.innerWidth * 0.6),
                  }}
                >
                  <div
                    className='gage-table__left-inner'
                    style={{
                      minWidth: _.ceil(this.state.innerWidth * 0.6) + 1,
                      cursor: isConferenceMode
                        ? 'pointer'
                        : this.state.isScrolling
                        ? 'grabbing'
                        : 'grab',
                    }}
                  >
                    <div
                      id='infinityscroll-target'
                      ref={this._scroller}
                      onMouseDown={this.onMouseDown}
                      onMouseMove={this.onMouseMove}
                    >
                      <table className='data-table'>
                        <thead className='data-table__header'>
                          <tr>
                            {!isConferenceMode && (
                              <React.Fragment>
                                <th className='data-table__head'>
                                  <div />
                                </th>
                                <th className='data-table__head'>日付</th>
                                <th className='data-table__head'>ステータス</th>
                              </React.Fragment>
                            )}
                            <th className='data-table__head'>協力会社名</th>
                            <th className='data-table__head'>作業場所</th>
                            <th className='data-table__head'>元請担当者</th>
                            {/* {isConferenceMode && (
                              <th
                                id='value-table--machinery-schedule'
                                style={{
                                  width: '40%',
                                  minWidth: '40vw',
                                  backgroundColor: '#666666',
                                  zIndex: 2,
                                }}
                              >
                                <TimeBarHeader
                                  scheduleLimitTimes={
                                    this.state.scheduleLimitTimes
                                  }
                                />
                              </th>
                            )} */}
                          </tr>
                        </thead>
                        {_.map(this.state.machinerySortedIds, machineryId =>
                          this.subItemCount(machineryId) === 0 ? null : (
                            <MachineryUsesContents
                              key={machineryId}
                              machinery={this.getMachineryById(machineryId)}
                              selectedGroup={this.isSelectedGroup(machineryId)}
                              isSelected={this.isSelected}
                              dialogs={this.events.modal}
                              callbacks={this.events.table}
                              workHourZone={this.state.workHourZone}
                              isConferenceMode={isConferenceMode}
                              userRollId={this.state.roleId}
                              scheduleLimitTimes={this.state.scheduleLimitTimes}
                              disabledTimes={_.filter(
                                this.state.disabledTimes,
                                time => {
                                  return time.target_id === machineryId;
                                }
                              )}
                              viewOnlyFlag={this.state.viewOnlyFlag}
                              isTimeBarReset={this.state.isTimeBarReset}
                              onToggleApprovalSingle={
                                this.onToggleApprovalSingle
                              }
                            />
                          )
                        )}
                      </table>
                      <InfinityScrollLoad
                        targetId='scroll-parent'
                        total={this.state.total}
                        isLoading={this.state.isLoading}
                        callback={this.getMachineries}
                      />
                    </div>
                  </div>
                </div>
                {
                  <div
                    className='gage-table__right no-shadow'
                    ref={this._rightTable}
                    style={{
                      minWidth: _.floor(this.state.innerWidth * 0.4),
                    }}
                  >
                    <div>
                      <table
                        className='data-table'
                        style={{ position: 'relative', overflowX: 'auto' }}
                      >
                        <thead className='data-table__header'>
                          <tr>
                            <th
                              id='value-table--machinery-schedule'
                              style={{
                                backgroundColor: '#666666',
                                zIndex: 3,
                              }}
                            >
                              <TimeBarHeader
                                scheduleLimitTimes={
                                  this.state.scheduleLimitTimes
                                }
                              />
                            </th>
                          </tr>
                        </thead>
                        {_.map(this.state.machinerySortedIds, machineryId => {
                          const machinery = _.find(
                            this.state.machineries,
                            machinery => machinery.id === machineryId
                          );
                          return _.isEmpty(machinery.machineryUses) ? null : (
                            <tbody
                              id={`group-${machinery.id}`}
                              key={machinery.id}
                              className='table__group show'
                            >
                              <tr className='table-section-header'>
                                <td
                                  className='data-table__gage-cover'
                                  style={{ borderTop: '1px solid #7C7C7C' }}
                                >
                                  <span className='data-table__gage-cover-spacer' />
                                </td>
                              </tr>
                              {_.chain(machinery.machineryUses)
                                .filter(machineryUse => {
                                  return (
                                    machineryUse.work_hour_zone ==
                                    this.state.workHourZone
                                  );
                                })
                                .map(machineryUse => {
                                  const isLinkedIchiPlusMachinery = _.some(
                                    machinery.external_system_machineries,
                                    {
                                      external_system_type:
                                        EXTERNAL_SYSTEM_TYPE.ICHI_PLUS,
                                    }
                                  );
                                  return (
                                    <tr
                                      key={machineryUse.id}
                                      className='data-table__item'
                                    >
                                      <td
                                        className='data-table__gage-bg'
                                        data-unlink
                                      >
                                        <SchaduleBar
                                          useStartTime={
                                            machineryUse.use_start_time
                                          }
                                          useEndTime={machineryUse.use_end_time}
                                          spotFlag={machineryUse.spot_flag}
                                          data={machineryUse}
                                          callback={
                                            this.events.table.handleGageUpdate
                                          }
                                          isForeman={isTargetRoleId(
                                            [USER_ROLES.foreman],
                                            this.state.roleId
                                          )}
                                          isGate={false}
                                          scheduleLimitTimes={
                                            this.state.scheduleLimitTimes
                                          }
                                          disabledTimes={_.filter(
                                            this.state.disabledTimes,
                                            time => {
                                              return (
                                                time.target_id === machineryId
                                              );
                                            }
                                          )}
                                          viewOnlyFlag={
                                            this.state.viewOnlyFlag ||
                                            isLinkedIchiPlusMachinery
                                          }
                                          isTimeBarReset={
                                            this.state.isTimeBarReset
                                          }
                                          tableRef={this._rightTable}
                                        />
                                      </td>
                                    </tr>
                                  );
                                })
                                .value()}
                              <tr
                                className='see-more'
                                style={
                                  machinery.machineryUseLoaded
                                    ? { display: 'none' }
                                    : { display: 'table-row' }
                                }
                              >
                                <td colSpan='8'>
                                  <button
                                    className='see-more__button see-more__button__blue'
                                    onClick={() =>
                                      this.events.table.handleSeeMore(
                                        machinery.id
                                      )
                                    }
                                  >
                                    <i className='see-more__button__icon' />
                                    <p className='see-more__button__text'>
                                      さらに表示する
                                    </p>
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          );
                        })}
                      </table>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
        <Confirmation
          visible={this.state.modalVisible.approval === true}
          title={messageUtility.getMessage(
            'I-001-407',
            `${SCHEDULE_TYPES.machinery.name}予定`
          )}
          message={messageUtility.getMessage(
            'I-001-404',
            `${SCHEDULE_TYPES.machinery.name}予定`
          )}
          confirmButtonText={messageUtility.getMessage('I-000-007')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          onConfirm={this.events.modal.approval}
          onCancel={() => this.events.modal.handleVisible('approval')}
        />
        <Confirmation
          visible={this.state.modalVisible.disapproval === true}
          title={messageUtility.getMessage(
            'I-001-408',
            `${SCHEDULE_TYPES.machinery.name}予定`
          )}
          message={messageUtility.getMessage(
            'I-001-417',
            `${SCHEDULE_TYPES.machinery.name}予定`
          )}
          confirmButtonText={messageUtility.getMessage('I-000-020')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          isNegative={true}
          onConfirm={this.events.modal.disapproval}
          onCancel={() => this.events.modal.handleVisible('disapproval')}
        />
        <Confirmation
          visible={this.state.modalVisible.approvalSingle === true}
          title={messageUtility.getMessage(
            'I-001-407',
            `${SCHEDULE_TYPES.machinery.name}予定`
          )}
          message={messageUtility.getMessage(
            'I-001-404',
            `${SCHEDULE_TYPES.machinery.name}予定`
          )}
          confirmButtonText={messageUtility.getMessage('I-000-007')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          onConfirm={this.updateApprovalFlgSingle}
          onCancel={() => this.events.modal.handleVisible('approvalSingle')}
        />
        <Confirmation
          visible={this.state.modalVisible.disapprovalSingle === true}
          title={messageUtility.getMessage(
            'I-001-408',
            `${SCHEDULE_TYPES.machinery.name}予定`
          )}
          message={messageUtility.getMessage(
            'I-001-417',
            `${SCHEDULE_TYPES.machinery.name}予定`
          )}
          confirmButtonText={messageUtility.getMessage('I-000-020')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          isNegative={true}
          onConfirm={this.updateApprovalFlgSingle}
          onCancel={() => this.events.modal.handleVisible('disapprovalSingle')}
        />
        <DisableTime
          visible={this.state.modalVisible.disableTime === true}
          loadingDisabledTimes={this.state.loadingDisabledTimes}
          workTime={this.state.workTime}
          disabledTimes={this.state.disabledTimes}
          scheduleLimitTimes={this.state.scheduleLimitTimes}
          callbacks={this.events.modal}
          planType={SCHEDULE_TYPES.machinery.name}
          idUsePlanName='machinery-uses'
        />
        <Modal modalRoot='root' modalState={this.state.modalVisible.documents}>
          <MachineryUseDocuments
            show={this.state.modalVisible.documents}
            calling={this.state.calling}
            callbacks={this.events.modal}
          />
        </Modal>
        <Information
          visible={this.state.modalVisible.documentsError === true}
          message={this.state.apiMessage}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() => this.events.modal.handleVisible('documentsError')}
          buttonClassName='btn--sm--sub'
        />
        <CopyPlan
          visible={this.state.modalVisible.copy === true}
          setKey='use_date'
          targetDate={this.state.use_date}
          callbacks={this.events.modal}
        />
        <Confirmation
          visible={this.state.modalVisible.confirmation === true}
          message={messageUtility.getMessage('I-001-310')}
          confirmButtonText={messageUtility.getMessage('I-000-021')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          isNegative={true}
          onConfirm={this.events.modal.destroy}
          onCancel={() => this.events.modal.handleVisible('disableTime')}
        />
        <Information
          visible={this.state.modalVisible.success === true}
          message={messageUtility.getMessage('I-001-311')}
          buttonText={messageUtility.getMessage('I-000-008')}
          onClose={() => this.events.modal.handleVisible('success')}
          buttonClassName='btn--sm--sub'
        />
        <Information
          visible={this.state.modalVisible.failure === true}
          message={messageUtility.getMessage('E-001-307')}
          buttonText={messageUtility.getMessage('I-000-008')}
          onClose={() => this.events.modal.handleVisible('failure')}
          buttonClassName='btn--sm--sub'
        />
        <Information
          title={this.state.modalVisible.approvalTitle}
          visible={this.state.modalVisible.approvalStatus === true}
          message={this.state.modalVisible.approvalMessage}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() => this.events.modal.handleVisible('approvalStatus')}
          multilineText={true}
        />

        {/* 時間更新権限エラーダイアログ */}
        <Information
          visible={this.state.modalVisible.timeForbiddenError === true}
          message='権限が無いため、時間の更新に失敗しました。'
          buttonText='了解'
          onClose={() => this.events.modal.handleVisible('timeForbiddenError')}
          buttonClassName='btn--sm--sub'
        />

        {/* コピー権限エラーダイアログ */}
        <Information
          visible={this.state.modalVisible.copyForbiddenError === true}
          message='権限が無いため、予定のコピーに失敗しました。'
          buttonText='了解'
          onClose={() => this.events.modal.handleVisible('copyForbiddenError')}
          buttonClassName='btn--sm--sub'
        />

        <Information
          title={messageUtility.getMessage('I-001-434')}
          visible={this.state.modalVisible.copyNotComplete === true}
          message={messageUtility.getMessage(
            'I-001-435',
            `${SCHEDULE_TYPES.machinery.name}予定`
          )}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() => this.events.modal.handleVisible('copyNotComplete')}
          multilineText={true}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/MachineryUses.jsx